import React from "react";
// import { Link } from "react-router-dom";
// import { Rating } from "@material-ui/lab";
import { useCurrency } from "../../context/CurrencyContext";
import { useNavigate } from "react-router-dom";

// import { useNavigate } from "react-router-dom";

const ProductCard = ({ product, detailRoute = "/product" }) => {
  const { formatPrice, getPrice } = useCurrency();
  const navigate = useNavigate();
  
  // Check if product has discounted price
  const hasDiscount = product?.discountedPrice && 
    ((product.discountedPrice.bhd > 0 && product.discountedPrice.bhd < product.price?.bhd) ||
     (product.discountedPrice.usd > 0 && product.discountedPrice.usd < product.price?.usd));
  
  const displayPrice = hasDiscount ? product.discountedPrice : product.price;
  const actualPrice = product.price;
  const normalizedGender = String(product?.gender || '').trim().toLowerCase();
  const isWomenProduct = normalizedGender === 'women' || normalizedGender === 'woman';
  const actualPriceValue = getPrice(actualPrice).value;
  const displayPriceValue = getPrice(displayPrice).value;
  const discountPercentage = hasDiscount && actualPriceValue > 0
    ? Math.round(((actualPriceValue - displayPriceValue) / actualPriceValue) * 100)
    : 0;
  const productUrl = `${detailRoute}/${product?._id || ''}`;
  const handleProductNavigation = (e) => {
    e.preventDefault();
    if (product?._id) {
      navigate(productUrl);
    }
  };
  // const navigate = useNavigate();

  // const navigateToProduct = (e) => {
  //   // e.preventDefault();
  //   // const data = {
  //   //   subtotal,
  //   //   shippingCharges,
  //   //   tax,
  //   //   totalPrice,
  //   // };

  //   // sessionStorage.setItem("orderInfo", JSON.stringify(data));

  //   navigate(`/product/${`${product._id}`}`);
  // };
  return (
    /*
    <Link className="productCard" to={`/product/${product._id}`}>
      <img src={product.images[0].url} alt={product.name} />
      <p>{product.name}</p>
      <div>
        <Rating {...options} />{" "}
        <span className="productCardSpan">
          {" "}
          ({product.numOfReviews} Reviews)
        </span>
      </div>
      <span>{`$${product.price}`}</span>
    </Link>
    */

    <a className={`productCard col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 ${isWomenProduct ? 'product-card-women' : ''}`} href={productUrl} onClick={handleProductNavigation}>
        <div className="single-product mb-15 wow fadeInUp" data-wow-delay=".1s">
            <div className="product-thumb">
                <img 
                    src={(product?.images && product.images.length > 0 && product.images[0]?.url) || '/placeholder-image.svg'} 
                    alt={product?.name || 'Product'} 
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                        if (!e.target.src.endsWith('/placeholder-image.svg')) { e.target.src = '/placeholder-image.svg'; }
                    }}
                />
                <div className="cart-btn cart-btn-1 p-abs">
                    <a href={productUrl} onClick={handleProductNavigation}>View Details</a>
                    {/* <a href='' onClick={navigateToProduct()}>View Details</a> */}
                </div>
                {discountPercentage > 0 && (
                    <span className="discount product-discount-badge p-abs">
                        {discountPercentage}% OFF
                    </span>
                )}
                <div className="product-action product-action-1 p-abs d-none">
                    <a href="#!" className="icon-box icon-box-1" data-bs-toggle="modal" data-bs-target="#productModal">
                        <i className="fal fa-eye"></i>
                        <i className="fal fa-eye"></i>
                    </a>
                </div>
            </div>
            <div className="product-content">
                <h4 className="pro-title pro-title-2">
                    <a href={productUrl} onClick={handleProductNavigation}>{product?.name || 'Unnamed Product'}</a>
                </h4>
                <div className="pro-price">
                    {hasDiscount ? (
                        <>
                            <span style={{ textDecoration: 'line-through', color: '#999', marginRight: '8px' }}>
                                {formatPrice(actualPrice)}
                            </span>
                            <span className="product-sale-price" style={{ color: '#e74c3c', fontWeight: 'bold' }}>
                                {formatPrice(displayPrice)}
                            </span>
                        </>
                    ) : (
                        <span className="product-regular-price">{product?.price ? formatPrice(product.price) : 'Price not available'}</span>
                    )}
                </div>
                <div className="rating d-none">
                    <i className="fal fa-star active"></i>
                    <i className="fal fa-star active"></i>
                    <i className="fal fa-star active"></i>
                    <i className="fal fa-star"></i>
                    <i className="fal fa-star"></i>
                </div>
            </div>
        </div>
    </a>

  );
};

export default ProductCard;
